import { END_POINTS } from "../constants/urls";
import {
  CommonResponseType,
  MyNotification,
  Notification,
} from "../types/General";
import emptySplitApi from "../utils/rtk";

export const notificationsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addNotification: builder.mutation<
      CommonResponseType,
      {
        title: string;
        content: string;
        type: string;
        broadcastReceivers: string[];
        isSendToAll: boolean;
      }
    >({
      query: (body) => ({
        url: END_POINTS.notificationsAdd,
        method: "POST",
        body,
      }),
    }),
    getNotifications: builder.query<
      CommonResponseType<{ list: Notification[]; totalCount: number }>,
      { page: number; limit: number; search?: string }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.notificationsGet}?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
    deleteNotification: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.notificationsDelete}/${id}`,
        method: "DELETE",
      }),
    }),
    getNotificationDetail: builder.query<
      CommonResponseType<{ list: Notification[] }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.notificationsGet}/${id}`,
        method: "GET",
      }),
    }),
    getMyNotifications: builder.query<
      CommonResponseType<{ list: MyNotification[]; totalCount: number }>,
      { page: number; limit: number; search?: string }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.notificationsMyNotifications}?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddNotificationMutation,
  useLazyGetNotificationsQuery,
  useDeleteNotificationMutation,
  useLazyGetNotificationDetailQuery,
  useLazyGetMyNotificationsQuery,
} = notificationsApi;
